export const getIdsForGridSelectedRows = (rowSelectionModel, data) => {
  const { type, ids } = rowSelectionModel;

  if (type === "exclude") {
    return data.filter(row => !ids.has(row.id)).map(row => row.id);
  }

  return Array.from(ids);
};